// extracted by mini-css-extract-plugin
module.exports = {"nav":"style_nav__1k-TH","nav-link":"style_nav-link__19bMK","-active":"style_-active__BJm1d","-close":"style_-close__2mKeq"};